export default "__VITE_ASSET__RHWu3jlj__"